import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  // isMobileResolution = false;

  // slides = [
  //   {img: "assets/img/item1.png"},
  //   {img: "assets/img/item2.png"},
  //   {img: "assets/img/item3.png"},
  //   {img: "assets/img/item4.png"},
  //   {img: "assets/img/item5.png"},
  //   {img: "assets/img/item6.png"},
  //   {img: "assets/img/item7.png"},
  //   {img: "assets/img/item8.png"},
  //   {img: "assets/img/item9.png"},
  //   {img: "assets/img/item10.png"},
  // ];
  // slideConfig = {"slidesToShow": 4, "slidesToScroll": 4};
  
  // addSlide() {
  //   this.slides.push({img: "http://placehold.it/350x150/777777"})
  // }
  
  // removeSlide() {
  //   this.slides.length = this.slides.length - 1;
  // }
  
  // slickInit(e) {
  //   console.log('slick initialized');
  // }
  
  // breakpoint(e) {
  //   console.log('breakpoint');
  // }
  
  // afterChange(e) {
  //   console.log('afterChange');
  // }
  
  // beforeChange(e) {
  //   console.log('beforeChange');
  // }  


  constructor() {
    // if (window.innerWidth < 768) {
    //   this.isMobileResolution = true;
    // } else {
    //   this.isMobileResolution = false;
    // }
   }

  //  public getIsMobileResolution(): boolean {
  //   return this.isMobileResolution;
  // }

  ngOnInit(): void {

  }

}
